/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export function designerPathEncoding(segment: string) {
    let res = segment;

    if (segment) {
        res = segment.replace('/', '%2F')
    }

    return res;
}
